var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavorisFill = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M10.025.025c.376 0 .702.201.852.524l2.438 5.266a.435.435 0 00.332.236l5.598.868a.91.91 0 01.735.598c.102.3.028.619-.196.853l-4.17 4.333a.351.351 0 00-.1.303l.967 6.01a.84.84 0 01-.365.834.966.966 0 01-1.028.05l-4.826-2.706a.497.497 0 00-.473 0L4.963 19.9a.976.976 0 01-1.03-.05.837.837 0 01-.363-.834l.966-6.009a.36.36 0 00-.1-.304L.267 8.37a.829.829 0 01-.198-.852.91.91 0 01.735-.599l5.6-.868a.437.437 0 00.333-.237L9.174.55a.922.922 0 01.851-.524z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#B2B2B2",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FCE06B",
  mask: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-2 -2)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavorisFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favoris-fill.b878d497831c613e4d83c35f90e679e8.svg";